export const getQuestionUuidFromPath = (path) => path.match(/^[^[^.]*/)?.[0]

export default getQuestionUuidFromPath
